<template>
    <div>
        <Row :gutter="16">
            <Card>
                <p slot="title">{{t.routerName}}</p>
                <Row>
                    <Form :model="formItem" :label-width="105" label-position="right"
                          ref="form">
                        <Row>
                            <Col>
                                <FormItem :label="t.dict.label" prop="label">
                                    <Input v-model="formItem.label" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.dict.sortOrder" prop="sortOrder">
                                    <Input v-model="formItem.sortOrder" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.dict.status" prop="status">
                                    <Input v-model="formItem.status" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.dict.category" prop="category">
                                    <Input v-model="formItem.category" readonly></Input>
                                </FormItem>
                                <FormItem :label="labelItem.data1" prop="data1" v-if="showFieldFlg(0)">
                                    <Input v-model="formItem.data1" readonly></Input>
                                </FormItem>
                                <FormItem :label="labelItem.data2" prop="data2" v-if="showFieldFlg(1)">
                                    <Input v-model="formItem.data2" readonly></Input>
                                </FormItem>
                                <FormItem :label="labelItem.data3" prop="data3" v-if="showFieldFlg(2)">
                                    <Input v-model="formItem.data3" readonly></Input>
                                </FormItem>
                                <FormItem :label="labelItem.data4" prop="data4" v-if="showFieldFlg(3)">
                                    <Input v-model="formItem.data4" readonly></Input>
                                </FormItem>
                                <FormItem :label="labelItem.data5" prop="data5" v-if="showFieldFlg(4)">
                                    <Input v-model="formItem.data5" readonly></Input>
                                </FormItem>
                                <FormItem :label="labelItem.data6" prop="data6" v-if="showFieldFlg(5)">
                                    <Input v-model="formItem.data6" readonly></Input>
                                </FormItem>
                                <FormItem :label="labelItem.data7" prop="data7" v-if="showFieldFlg(6)">
                                    <Input v-model="formItem.data7" readonly></Input>
                                </FormItem>
                                <FormItem :label="labelItem.data8" prop="data8" v-if="showFieldFlg(7)">
                                    <Input v-model="formItem.data8" readonly></Input>
                                </FormItem>
                                <FormItem :label="labelItem.data9" prop="data9" v-if="showFieldFlg(8)">
                                    <Input v-model="formItem.data9" readonly></Input>
                                </FormItem>
                                <FormItem :label="labelItem.data10" prop="data10" v-if="showFieldFlg(9)">
                                    <Input v-model="formItem.data10" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.dict.body" v-if="showFieldFlg(10)">
                                    <tinymce id="id1" v-model="formItem.body" :toolbar1="toolbar1"
                                             :other_options="other_options" readonly></tinymce>
                                </FormItem>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <span v-if="showFieldFlg(step-1)" v-for="step in 10" :key="step" style="float: right;">
                                    <div class="dist-upload-list" v-if="fieldExistsFlg(step-1) != null">
                                        <img :src="fieldExistsFlg(step-1)"/>
                                        <div class="dist-upload-list-cover">
                                            <Icon type="ios-eye-outline" @click="openPreviewImageModal(step-1)"></Icon>
                                        </div>
                                    </div>
                                    <div class="img-drag" v-else>
                                        <div style="width: 58px;height:58px;line-height: 58px;">
                                            <Icon type="ios-camera" size="20"></Icon>
                                        </div>
                                    </div>
                                </span>
                                <Modal v-model="previewImageModal" :width="previewImageModalWidth">
                                    <img :src="previewImage" style="max-width:100%;max-height:100%;">
                                    <div slot="footer">
                                        {{previewImageName}}
                                    </div>
                                </Modal>
                            </Col>
                        </Row>
                    </Form>
                </Row>
            </Card>
        </Row>
    </div>
</template>
<script>
import { getDictInfo } from '@/api/dict';
import { getConfigInfo } from '@/api/config';

export default {
    name: 'content_dict_detail',
    data() {
        const t = this.$_t();
        const msgUtil = this.$msgUtil;
        return {
            self: this,
            t: t,
            msgUtil: msgUtil,
            currentConfigInfoValIndex: -1,
            currentConfigInfo: null,
            previewImageModal: false,
            previewImage: null,
            thumbWidth: 0,
            previewImageName: '',
            labelItem: {
                data1: t.dict.data1,
                data2: t.dict.data2,
                data3: t.dict.data3,
                data4: t.dict.data4,
                data5: t.dict.data5,
                data6: t.dict.data6,
                data7: t.dict.data7,
                data8: t.dict.data8,
                data9: t.dict.data9,
                data10: t.dict.data10,
            },
            formItem: {
                configId: '',
                sortOrder: 0,
                label: '',
                data1: null,
                data2: null,
                data3: null,
                data4: null,
                data5: null,
                data6: null,
                data7: null,
                data8: null,
                data9: null,
                data10: null,
                status: '1',
                body: '',
                category: '',
            },
            ruleValidate: {},
            toolbar1:
                'newnote print preview',
            other_options: {
                height: 400,
                menubar: false,
                plugins: 'image code print preview',
            },
            loading: false,
        };
    },
    beforeCreate() {
        import('tinymce-i18n/langs/ja');
    },
    computed: {
        previewImageModalWidth() {
            return this.thumbWidth;
        },
    },
    methods: {
        //data1-data7属性存在的判定
        fieldExistsFlg(index) {
            if (index === 0) {
                return this.formItem.data1;
            } else if (index === 1) {
                return this.formItem.data2;
            } else if (index === 2) {
                return this.formItem.data3;
            } else if (index === 3) {
                return this.formItem.data4;
            } else if (index === 4) {
                return this.formItem.data5;
            } else if (index === 5) {
                return this.formItem.data6;
            } else if (index === 6) {
                return this.formItem.data7;
            } else if (index === 7) {
                return this.formItem.data8;
            } else if (index === 8) {
                return this.formItem.data9;
            } else if (index === 9) {
                return this.formItem.data10;
            }
        },
        //data1-data7和body默认表示爹判定逻辑
        showFieldFlg(index) {
            const configInfo = this.currentConfigInfo;
            if (configInfo == null) {
                return false;
            }
            if (index === 0) {
                return configInfo.value1 != null;
            } else if (index === 1) {
                return configInfo.value2 != null;
            } else if (index === 2) {
                return configInfo.value3 != null;
            } else if (index === 3) {
                return configInfo.value4 != null;
            } else if (index === 4) {
                return configInfo.value5 != null;
            } else if (index === 5) {
                return configInfo.value6 != null;
            } else if (index === 6) {
                return configInfo.value7 != null;
            } else if (index === 7) {
                return configInfo.value8 != null;
            } else if (index === 8) {
                return configInfo.value9 != null;
            } else if (index === 9) {
                return configInfo.value10 != null;
            } else if (index === 10) {
                return configInfo.type === '1';
            }
            return false;
        },
        //图片预览
        openPreviewImageModal(index) {
            let size = '0';
            if (index === 0) {
                this.previewImage = this.formItem.data1;
                size = this.currentConfigInfo.value1;
                this.previewImageName = this.labelItem.data1;
            } else if (index === 1) {
                this.previewImage = this.formItem.data2;
                size = this.currentConfigInfo.value2;
                this.previewImageName = this.labelItem.data2;
            } else if (index === 2) {
                this.previewImage = this.formItem.data3;
                size = this.currentConfigInfo.value3;
                this.previewImageName = this.labelItem.data3;
            } else if (index === 3) {
                this.previewImage = this.formItem.data4;
                size = this.currentConfigInfo.value4;
                this.previewImageName = this.labelItem.data4;
            } else if (index === 4) {
                this.previewImage = this.formItem.data5;
                size = this.currentConfigInfo.value5;
                this.previewImageName = this.labelItem.data5;
            } else if (index === 5) {
                this.previewImage = this.formItem.data6;
                size = this.currentConfigInfo.value6;
                this.previewImageName = this.labelItem.data6;
            } else if (index === 6) {
                this.previewImage = this.formItem.data7;
                size = this.currentConfigInfo.value7;
                this.previewImageName = this.labelItem.data7;
            } else if (index === 7) {
                this.previewImage = this.formItem.data8;
                size = this.currentConfigInfo.value8;
                this.previewImageName = this.labelItem.data8;
            } else if (index === 8) {
                this.previewImage = this.formItem.data9;
                size = this.currentConfigInfo.value9;
                this.previewImageName = this.labelItem.data9;
            } else if (index === 9) {
                this.previewImage = this.formItem.data10;
                size = this.currentConfigInfo.value10;
                this.previewImageName = this.labelItem.data10;
            }
            if (size != null && size !== '0') {
                let width = parseInt(size.split('x')[0]) + 32;
                if (width < 100) {
                    width = 120;
                }
                this.thumbWidth = width;
            }
            this.previewImageModal = true;
        },
    },
    async mounted() {
        //得到字典情报
        const dictInfo = await getDictInfo(this.$route.params.id);
        if (dictInfo.dict != null) {
            this.formItem = dictInfo.dict;
            const configInfo = await getConfigInfo(dictInfo.dict.configId);
            if (configInfo.config != null) {
                this.currentConfigInfo = configInfo.config;
                this.formItem.category = this.currentConfigInfo.name;
                //动态设定标签名称
                this.labelItem.data1 = this.currentConfigInfo.key1;
                this.labelItem.data2 = this.currentConfigInfo.key2;
                this.labelItem.data3 = this.currentConfigInfo.key3;
                this.labelItem.data4 = this.currentConfigInfo.key4;
                this.labelItem.data5 = this.currentConfigInfo.key5;
                this.labelItem.data6 = this.currentConfigInfo.key6;
                this.labelItem.data7 = this.currentConfigInfo.key7;
                this.labelItem.data8 = this.currentConfigInfo.key8;
                this.labelItem.data9 = this.currentConfigInfo.key9;
                this.labelItem.data10 = this.currentConfigInfo.key10;
            }

            //状态判断
            if (this.formItem.status === '1') {
                this.formItem.status = this.t.dict.open;
            } else if (this.formItem.status === '0') {
                this.formItem.status = this.t.dict.close;
            }
        }
    },
};
</script>
<style lang="less" scoped>
.img-drag {
    background: #fff;
    border: 1px dashed #dcdee2;
    border-radius: 4px;
    text-align: center;
    /*cursor: pointer;*/
    position: relative;
    overflow: hidden;
    transition: border-color 0.2s ease;
    display: inline-block;
    width: 58px;
    height: 58px;
    margin-left: 10px;
    &:hover {
        border: 1px dashed #2d8cf0;
    }
    img {
        width: 100%;
        vertical-align: middle;
    }
}

.sub-cropper {
    height: 600px;
    margin-bottom: 10px;
}

@keyframes slide {
    0% {
        background-position: 0 0;
    }
    100% {
        background-position: -100% 0;
    }
}

@media screen and (max-width: 1080px) {
    .sub-cropper {
        height: 600px;
    }
}

.dist-upload-list {
    display: inline-block;
    width: 60px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
    margin-right: 4px;
}

.dist-upload-list img {
    width: 100%;
    height: 100%;
}

.dist-upload-list-cover {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
}

.dist-upload-list:hover .dist-upload-list-cover {
    display: block;
}

.dist-upload-list-cover i {
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
}
</style>
<style lang="less" src="@/assets/less/i-switch.less" scoped>
</style>
